import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from "@angular/forms";
import { BuyerService } from 'src/app/core/services/buyer.service';
import Swal from 'sweetalert2';
import { FetchDataService } from 'src/app/core/services/fetch-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  allNotification: any[] = [];

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private bs: BuyerService,
    private fd: FetchDataService,
    private router: Router,
      public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.markReadNotificationBuyer();
    this.getNotification();
  }

  getNotification(): void {
    const uid = localStorage.getItem('uid');
    if (!uid) return;

    this.bs.getSellerNotificaton(uid).subscribe((res: any) => {
      if (res.code === 1) {
        this.allNotification = res.result;
      }
    });

    this.markReadNotificationBuyer();
  }

  markReadNotificationBuyer(): void {
    const uid = localStorage.getItem('uid');
    if (!uid) return;

    this.bs.markReadNotification(uid).subscribe((res: any) => {
      console.log('Notifications marked as read.');
    });
  }

  handleNotificationClick(notification: any): void {
    if (notification.type === 'edit_offer') {
      // Navigate with query param
      this.router.navigate(['/buyer/landing'], {
        queryParams: { highlightId: notification.action_id }
      });
    } else {
      console.warn('Unhandled notification type:', notification.type);
    }
  }
}
